import { UNIT } from '../../../../constant'
import { WEIGHT_UNIT_KG_PER_LB } from '../../constants'

export function getKgsWeightUtil (weight, weightUnit) {
  if (weightUnit === UNIT.METRIC) {
    return weight
  }
  return weight * WEIGHT_UNIT_KG_PER_LB
}
